import { Box, Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { ExtensionBadge } from '~/components/shared/ExtensionBadge'
import { ReferButton } from '~/pages/WebPhone/ReferButton'
import { Size } from '~/types/ThemeTypes'

import { useTransferTargetStyle } from './componentStyles/TransferTarget.style'

interface TransferTargetProps {
  id: string | number
  number: string
  name: string
  onTransfer: (target: string) => void
}
export const TransferTarget = ({
  id,
  number,
  name,
  onTransfer,
}: TransferTargetProps) => {
  const handleButtonClick = () => {
    onTransfer(number)
  }

  const styles = useTransferTargetStyle()

  return (
    <Flex key={id} sx={styles.container}>
      <Box sx={styles.label}>
        <ExtensionBadge size={Size.lg} extension={number} />
        <Text sx={styles.name} noOfLines={0}>
          {name}
        </Text>
      </Box>
      <ReferButton
        sx={styles.button}
        buttonText="Transfer Call"
        onClick={handleButtonClick}
      />
    </Flex>
  )
}
